import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { fetchEvents } from '../services/strapi';
import TicketPricingTable from '../components/TicketPricingTable'
import VipInfo from '../components/VipInfo';
import CmsItem from '../components/CmsItem';

const EventDetail = () => {
  const { id } = useParams();
  const [event, setEvent] = useState(null);
  const baseUrl = process.env.REACT_APP_API_URL;
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchEventDetail = async () => {
      try {
        setLoading(true);
        const events = await fetchEvents(); // Fetch all events
        const selectedEvent = events.find((event) => event.id === parseInt(id, 10)); // Find event by ID
        setEvent(selectedEvent);
      } catch (error) {
        setError(error.message);
      } finally  {
        setLoading(false);
      }
    };

    fetchEventDetail();
  }, [id]);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <>
    <div className='event-detail'>
     <div className='event-detail__image'>
      {event.EventImage?.[0]?.formats?.large?.url && (
        <img 
            src={`${baseUrl}${event.EventImage[0].formats.large.url}`} 
            alt={event.Title} 
        />
      )}
      </div>

    <div className='event-detail__content'>
        <div className='event-detail__description'>
            <h1>{event.Title}</h1>
            <p>{event.Description}</p>
        </div>

        <div className='event-detail__info'>
            <p>Date: {new Date(event.Date).toLocaleDateString()}</p>
            <p>Time: {new Date(event.Date).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</p>
            <a className='button' href={event.BookingLink} rel="noopener noreferrer">Book Now</a>
        </div>


     {/* Price Information */}
        {event.PriceInformation &&  event.PriceInformation.Title.length > 0 ? (

        <div className='event-detail__tickets'>

            <h4>{event.PriceInformation.Subtitle}</h4>
            <h2><a className='event-detail__price-title' href='#'>{event.PriceInformation.Title}</a></h2>


            <TicketPricingTable pricingData={event.TicketType}/>
            <VipInfo vipInfo={event.PriceInformation.vipInfo}/>
        </div>

    ) : (
        <div className='event-detail__tickets'>No price information available.</div>
    )}
      </div>
    </div>

    <div className='event-cms'>
      <CmsItem cmsData={event.cmsText}/>
    </div>


    <div className='about-band'>
        <div className='about-band__image'>
        <img 
            src={`${baseUrl}${event.AboutBandImage.formats.large.url}`} 
            alt={event.Title} 
        />
        </div>

        <div className='about-band__content'>
            <h2>{event.AboutBand.Title}</h2>
            <p>{event.AboutBand.Description}</p>
            <a className='button' href={event.AboutBand.Url} rel="noopener noreferrer">{event.AboutBand.UrlText}</a>
        </div>
    </div>
      </>
  );
};

export default EventDetail;
